import { createSlice } from "@reduxjs/toolkit";

import { getProjectDetails } from "./action";

const initialState = {
  projectDetails: null,
  isStreamIndependet: false,
  illustoClipsProgress: {},
  projectInPublishModal: null,
};

export const illustoProjectSlice = createSlice({
  name: "illustoProject",
  initialState,
  reducers: {
    setProjectDetails: (state, action) => {
      state.projectDetails = action.payload;
      if (!action.payload) {
        state.isStreamIndependet = false;
      }
    },
    setIllustoClipsProgress: (state, action) => {
      state.illustoClipsProgress = action.payload;
    },
    setProjectInPublishModal: (state, action) => {
      state.projectInPublishModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectDetails.fulfilled, (state, action) => {
      if (action.payload.status) {
        state.projectDetails = action.payload.data.data.videoCompiledList[0];
        state.isStreamIndependet = true;
      }
    });
  },
});

export const { setProjectDetails, setIllustoClipsProgress, setProjectInPublishModal } = illustoProjectSlice.actions;

export default illustoProjectSlice.reducer;
